import { WithStyles, withStyles } from '@mui/styles';

import { ApiConnectionFirm } from './apiConnectionFirm';
import { muiStyles } from './apiConnectionFirmStyles';

export interface ApiConnectionFirmProps extends WithStyles<typeof muiStyles>{
    match: any;
}

export default withStyles(muiStyles)(ApiConnectionFirm);